import { InstrumentCommissionDto } from './InstrumentCommissionDto'
import { NameDto } from './NameDto'
import { CurrencyType } from './WalletDto'

export interface IntroducingBrokerDetailsDto {
  instrumentCommissions?: InstrumentCommissionDto[]
  id: string
  name: string | null
  status: IntroducingBrokerStatus
  client?: Client
  parent?: null | { id: string; name: string | null }
  registeredAt: string
  multiLevelRegisteredAt?: string | null
  multiLevelPercentage?: number | null
  multiTierRegisteredAt: string | null
  defaultProgramRegisteredAt: string | null
  commissionCalculationStatus: NameDto<number>
  profile?: IBProfile
  assignee?: AssigneeDto | null
  ibUserGetsClients?: boolean
  sibAssignee?: AssigneeDto | null
  sibIsAutoAssigned: boolean | null
  loyaltyDetails: LoyaltyDetails
  loyaltyProgramEnabled: boolean
  notifications: IntroducingBrokerNotifications
  loyaltyProgramEligible: boolean
  restrictions?: NameDto[] | null
  tradingAccountsCount: number
  isLastMultiTierLevel: boolean
  hasMultiLevelCommission: boolean
}

export interface IntroducingBrokerNotifications {
  hasRebateApprovalsNotification: boolean
  hasRebateTransactionsNotification: boolean
}

export interface AssigneeDto {
  id: string
  name: string
  status: NameDto<number>
}

export interface IntroducingBrokerReferralDetailsDto {
  isDefaultCommissionPlan: boolean
  mainIbScheme: NameDto<IntroducingBrokerReferralTypes>
  code: string
}

export enum IntroducingBrokerReferralTypes {
  Default = 0,
  MultiTier = 1,
}

export enum LoyaltyBonusStatus {
  Created = 1,
  Approved = 2,
  Rejected = 3,
  Reversal = 4,
  Reversed = 5,
  Redeemed = 6,
}
export interface LoyaltyDetails {
  loyaltyLots: number
  currentTier?: LoyaltyTierDto | null
  nextTier?: LoyaltyTierDto
  nextSubTier: LoyaltyNextSubTierDto | null
  loyaltyRewards: LoyaltyRewardDto[]
  redeemableRewards: LoyaltyRewardDto[]
  tiers: LoyaltyTierDto[]
  loyaltyLotsToNextTier: number
}

export type LoyaltyTier =
  | 'Default'
  | 'Bronze 1'
  | 'Bronze 2'
  | 'Bronze 3'
  | 'Bronze'
  | 'Silver'
  | 'Gold'
  | 'Platinum'
  | 'Diamond'
  | 'Elite'
  | 'Elite Plus'
  | 'Legend'
  | 'Ultimate'
  | 'Ultra'

interface QuantityProgress {
  current: number
  required: number
  remaining: number
}
export interface LoyaltyTierDto {
  id: number
  name: LoyaltyTier | null
  htmlPrizeText: string | null
  label: string | null
  lots: QuantityProgress
  minLots: number
  maxLots: number
  minNotionalValue: number
  maxNotionalValue: number
  bonusNv: QuantityProgress
  amount: number
  shouldNotify: boolean
  order: number
  groupId: number
  imageUri: string | null
  isCurrent: boolean
  subTiers:
    | (LoyaltyTierClientDto & {
        ibReward: LoyaltyRewardDto | null
        isCurrent: boolean
        lots: QuantityProgress
        bonusNv: QuantityProgress
      })[]
    | null
  ibReward: LoyaltyRewardDto | null
}

export interface LoyaltyTierClientDto {
  id: number
  name: LoyaltyTier | null
  htmlPrizeText: string | null
  label: string | null
  minLots: number
  maxLots: number
  minNotionalValue: number
  maxNotionalValue: number
  amount: number
  shouldNotify: boolean
  order: number
  groupId: number
  imageUri: string | null
  subTiers: LoyaltyTierClientDto[] | null
}

export interface LoyaltyRewardDto {
  id: string
  tierId: number
  walletId: string
  currencyId: CurrencyType | null
  amount: number
  transactionId: string | null
  loyaltyBonusStatus: NameDto<number>
}

interface LoyaltyNextSubTierDto {
  id: number
  name: string | null
  htmlPrizeText: string | null
  lots: number
  available: boolean
}

export interface Client {
  id: string
  name: string | null
  introducingBroker: IntroducingBroker
  tickmillCompany: TickmillCompany
  teams: { id: string; team: string | null }[]
}

interface TickmillCompany {
  id: number
  name: string
}

interface IntroducingBroker {
  name: string | null
  id: string
}

export interface IntroducingBrokerStatus {
  name: string | null
  id: number
}

export interface IBProfile {
  accountGroups: {
    id: string
    name: string | null
    currency: NameDto<string>
  }[]
  standardCommissions: []
  id: string
  name: string | null
  description: string | null
  tickmillCompany: { id: number; name: string | null }
}
